import React from "react"
import { Link } from "gatsby"
import Follow from "../modal/follow-up"
import WebriQForm from "@webriq/gatsby-webriq-form"

import logo from "../../images/home/logo.png"

const footer = props => {
  return (
    <div>
      <div id="footer">
        <div className="footer-img-float">
          <svg
            width="300"
            height="103"
            viewBox="0 0 384 103"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.59061 71.8176L379.031 102.566C381.944 102.805 384.44 100.505 384.44 97.5823V36.6753C384.44 34.0725 382.444 31.9051 379.85 31.6921L5.40906 0.944069C2.49606 0.704857 -0.000152588 3.00449 -0.000152588 5.92729V66.8343C-0.000152588 69.4371 1.99658 71.6046 4.59061 71.8176Z"
              fill="url(#paint0_linear)"
            />
            <defs>
              <linearGradient
                id="paint0_linear"
                x1="384.44"
                y1="58.4999"
                x2="-4.48224"
                y2="58.4999"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#D0A51C" />
                <stop offset="0.104647" stopColor="#FFE284" />
                <stop offset="0.307463" stopColor="#BF981B" />
                <stop offset="0.679265" stopColor="#FFD85A" />
                <stop offset="0.752365" stopColor="#FFE79A" />
                <stop offset="0.85996" stopColor="#FCD559" />
                <stop offset="1" stopColor="#BD9105" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <section id="contact">
          <div className="container">
            <div className="row">
              <div className="col-12 mb-5">
                <div className="section-heading text-center">
                  <h2 className="section-title mb-4 text-white">Contact Us</h2>
                  <h5 className="text-white">
                    Need help? Our helpful and always ready experts are a click
                    or call away.
                  </h5>
                </div>
              </div>
              <div className="col-12">
                <div className="contact-body">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="contact-form">
                        <h4 className="contact-title f-400 mb-4">
                          Leave us a message
                        </h4>
                        <WebriQForm
                          name="Contact Us"
                          id="contact-form"
                          className="contact-form-wrapper"
                          data-form-id="984b5822-c26d-4ecb-9602-5799eeb07e98"
                          data-thankyou-url="/thank-you"
                        >
                          <div className="form-group">
                            <input
                              className="form-control contact-input"
                              type="text"
                              name="Name"
                              placeholder="Name"
                            />
                          </div>
                          <div className="form-group">
                            <input
                              className="form-control contact-input"
                              type="text"
                              name="Email"
                              placeholder="Email Address"
                            />
                          </div>
                          <div className="form-group mb-4">
                            <textarea
                              className="form-control contact-textarea"
                              name="Message"
                              placeholder="Your Message"
                              rows="4"
                            ></textarea>
                          </div>
                          <div className="col-12">
                            <div className="form-group">
                              <div className="webriq-recaptcha" />
                            </div>
                          </div>
                          <div className="form-group">
                            <button
                              className="btn btn-primary contact-cta"
                              type="submit"
                            >
                              SEND
                            </button>
                          </div>
                        </WebriQForm>
                      </div>
                    </div>
                    <div className="col-lg-5 ml-auto">
                      <div className="get-touch text-left mb-4">
                        <h4 className="contact-title f-400 mb-0">
                          Get in touch
                        </h4>
                        <hr className="section-hr-left" />
                        <div className="contact-location d-flex justify-content-start align-items-center mb-4">
                          <svg
                            width="14"
                            height="40"
                            viewBox="0 14 18 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="location-icon mr-3"
                          >
                            <path
                              d="M7.85645 4.24902C6.81478 4.24902 5.92936 4.61361 5.2002 5.34277C4.47103 6.07194 4.10645 6.95736 4.10645 7.99902C4.10645 9.04069 4.47103 9.92611 5.2002 10.6553C5.92936 11.3844 6.81478 11.749 7.85645 11.749C8.89811 11.749 9.78353 11.3844 10.5127 10.6553C11.2419 9.92611 11.6064 9.04069 11.6064 7.99902C11.6064 6.95736 11.2419 6.07194 10.5127 5.34277C9.78353 4.61361 8.89811 4.24902 7.85645 4.24902ZM7.85645 10.499C7.17936 10.499 6.59342 10.2516 6.09863 9.75684C5.60384 9.26204 5.35645 8.67611 5.35645 7.99902C5.35645 7.32194 5.60384 6.736 6.09863 6.24121C6.59342 5.74642 7.17936 5.49902 7.85645 5.49902C8.53353 5.49902 9.11947 5.74642 9.61426 6.24121C10.109 6.736 10.3564 7.32194 10.3564 7.99902C10.3564 8.67611 10.109 9.26204 9.61426 9.75684C9.11947 10.2516 8.53353 10.499 7.85645 10.499ZM7.85645 0.499023C6.50228 0.499023 5.25228 0.837565 4.10645 1.51465C2.96061 2.19173 2.04915 3.10319 1.37207 4.24902C0.694987 5.39486 0.356445 6.64486 0.356445 7.99902C0.356445 8.83236 0.460612 9.57454 0.668945 10.2256C0.877279 10.8506 1.28092 11.6318 1.87988 12.5693C2.29655 13.2204 3.15592 14.4834 4.45801 16.3584L7.0752 20.1084C7.25749 20.3688 7.5179 20.499 7.85645 20.499C8.19499 20.499 8.4554 20.3688 8.6377 20.1084L11.2549 16.3584C12.557 14.4834 13.4163 13.2204 13.833 12.5693C14.432 11.6318 14.8356 10.8506 15.0439 10.2256C15.2523 9.57454 15.3564 8.83236 15.3564 7.99902C15.3564 6.64486 15.0179 5.39486 14.3408 4.24902C13.6637 3.10319 12.7523 2.19173 11.6064 1.51465C10.4606 0.837565 9.21061 0.499023 7.85645 0.499023ZM7.85645 19.0146C7.23145 18.1032 6.42415 16.9443 5.43457 15.5381C4.18457 13.7412 3.36426 12.5563 2.97363 11.9834C2.42676 11.098 2.06217 10.3949 1.87988 9.87402C1.69759 9.32715 1.60645 8.70215 1.60645 7.99902C1.60645 7.16569 1.7627 6.37142 2.0752 5.61621C2.3877 4.861 2.84342 4.18392 3.44238 3.58496C4.04134 2.986 4.71842 2.53027 5.47363 2.21777C6.22884 1.90527 7.02311 1.74902 7.85645 1.74902C8.68978 1.74902 9.48405 1.90527 10.2393 2.21777C10.9945 2.53027 11.6715 2.986 12.2705 3.58496C12.8695 4.18392 13.3252 4.861 13.6377 5.61621C13.9502 6.37142 14.1064 7.16569 14.1064 7.99902C14.1064 8.70215 14.0153 9.32715 13.833 9.87402C13.6507 10.3949 13.2861 11.098 12.7393 11.9834C12.3486 12.5563 11.5283 13.7412 10.2783 15.5381L7.85645 19.0146Z"
                              fill="#0F001A"
                            />
                          </svg>

                          <h6 className="contact-info f-600">
                            1600 Stout St, Ste. 900
                            <br />
                            Denver, CO 80202
                          </h6>
                        </div>
                        <div className="contact-phone mb-4">
                          <a
                            className="d-flex justify-content-start align-items-center"
                            href="tel:8005068901"
                          >
                            <svg
                              width="14"
                              height="22"
                              viewBox="0 8 22 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="location-icon  mr-3"
                            >
                              <path
                                d="M19.2717 20.0625L20.1702 16.1172C20.2483 15.8307 20.2092 15.5573 20.053 15.2969C19.9228 15.0365 19.7275 14.8411 19.467 14.7109L15.2483 12.9141C14.9879 12.8099 14.7275 12.7839 14.467 12.8359C14.2066 12.9141 13.9853 13.0573 13.803 13.2656L12.0842 15.375C10.7301 14.6979 9.51912 13.8255 8.45142 12.7578C7.38371 11.6901 6.51131 10.4792 5.83423 9.125L7.9436 7.40625C8.15194 7.22396 8.28215 7.0026 8.33423 6.74219C8.41235 6.48177 8.39933 6.22135 8.29517 5.96094L6.49829 1.74219C6.36808 1.48177 6.17277 1.27344 5.91235 1.11719C5.65194 0.986979 5.3785 0.960937 5.09204 1.03906L1.14673 1.9375C0.886312 2.01562 0.664958 2.15885 0.482666 2.36719C0.300374 2.60156 0.209229 2.86198 0.209229 3.14844C0.209229 6.3776 1.01652 9.3724 2.6311 12.1328C4.21965 14.8411 6.35506 16.9766 9.03735 18.5391C11.8238 20.1797 14.8446 21 18.0999 21C18.3603 21 18.5946 20.9089 18.803 20.7266C19.0374 20.5443 19.1936 20.3229 19.2717 20.0625ZM1.45923 3.14844L5.36548 2.25L7.16235 6.46875L4.31079 8.77344C5.24829 10.8047 6.32902 12.4323 7.55298 13.6562C8.77694 14.8802 10.4045 15.9609 12.4358 16.8984L14.7405 14.0469L18.9592 15.8438L18.0608 19.75C15.066 19.75 12.2795 18.9948 9.70142 17.4844C7.17537 16 5.18319 14.0078 3.72485 11.5078C2.21444 8.92969 1.45923 6.14323 1.45923 3.14844Z"
                                fill="#0F001A"
                              />
                            </svg>

                            <h6 className="contact-info f-600">800-506-8901</h6>
                          </a>
                        </div>
                        <div className="contact-email">
                          <a
                            className="d-flex justify-content-start align-items-center"
                            href="mailto:info@nationalpartners.com"
                          >
                            <svg
                              width="16"
                              height="26"
                              viewBox="0 3 22 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="location-icon  mr-3"
                            >
                              <path
                                d="M18.125 0L1.875 0C1.35417 0 0.911458 0.182292 0.546875 0.546875C0.182292 0.911458 0 1.35417 0 1.875L0 13.125C0 13.6458 0.182292 14.0885 0.546875 14.4531C0.911458 14.8177 1.35417 15 1.875 15H18.125C18.6458 15 19.0885 14.8177 19.4531 14.4531C19.8177 14.0885 20 13.6458 20 13.125V1.875C20 1.35417 19.8177 0.911458 19.4531 0.546875C19.0885 0.182292 18.6458 0 18.125 0ZM1.875 1.25L18.125 1.25C18.3073 1.25 18.4505 1.3151 18.5547 1.44531C18.6849 1.54948 18.75 1.69271 18.75 1.875V3.47656C17.8385 4.25781 15.8724 5.84635 12.8516 8.24219L12.4609 8.55469C11.9401 8.9974 11.5365 9.3099 11.25 9.49219C10.7552 9.83073 10.3385 10 10 10C9.66146 10 9.24479 9.83073 8.75 9.49219C8.4375 9.3099 8.02083 8.9974 7.5 8.55469L7.14844 8.24219C4.1276 5.84635 2.16146 4.25781 1.25 3.47656V1.875C1.25 1.69271 1.30208 1.54948 1.40625 1.44531C1.53646 1.3151 1.69271 1.25 1.875 1.25ZM18.125 13.75H1.875C1.69271 13.75 1.53646 13.6979 1.40625 13.5938C1.30208 13.4635 1.25 13.3073 1.25 13.125L1.25 5.11719C2.16146 5.84635 3.86719 7.21354 6.36719 9.21875L6.75781 9.53125C7.35677 10.0521 7.85156 10.4297 8.24219 10.6641C8.89323 11.0547 9.47917 11.25 10 11.25C10.5208 11.25 11.1068 11.0547 11.7578 10.6641C12.1224 10.4297 12.6172 10.0521 13.2422 9.53125L13.6328 9.21875C16.1328 7.21354 17.8385 5.84635 18.75 5.11719V13.125C18.75 13.3073 18.6849 13.4635 18.5547 13.5938C18.4505 13.6979 18.3073 13.75 18.125 13.75Z"
                                fill="#0F001A"
                              />
                            </svg>

                            <h6 className="contact-info f-600">
                              info@nationalpartners.com
                            </h6>
                          </a>
                        </div>
                      </div>
                      <div className="connect-us text-left">
                        <h4 className="contact-title f-400 mb-0">
                          Connect with us
                        </h4>
                        <hr className="section-hr-left" />
                        <div className="connect-social d-flex justify-content-start align-items-center">
                          <a
                            className="linkedin mr-3"
                            href="https://www.linkedin.com/company/national-partners-pfco-llc/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="linkedin-icon "
                            >
                              <path
                                d="M18.5186 0H1.47639C0.661389 0 0 0.645833 0 1.44111V18.5569C0 19.3533 0.661389 20 1.47639 20H18.5186C19.3342 20 20 19.3533 20 18.5569V1.44111C20 0.645833 19.3342 0 18.5186 0ZM5.93167 17.0428H2.96389V7.49861H5.93167V17.0428ZM4.44778 6.19361C4.22188 6.19361 3.9982 6.1491 3.78952 6.06262C3.58083 5.97614 3.39123 5.84939 3.23155 5.68961C3.07187 5.52982 2.94524 5.34014 2.8589 5.1314C2.77255 4.92266 2.72819 4.69895 2.72833 4.47306C2.72833 4.01707 2.90947 3.57976 3.23191 3.25732C3.55434 2.93489 3.99165 2.75375 4.44764 2.75375C4.90363 2.75375 5.34094 2.93489 5.66337 3.25732C5.9858 3.57976 6.16694 4.01707 6.16694 4.47306C6.16694 4.92913 5.98586 5.36655 5.6635 5.68918C5.34113 6.01181 4.90386 6.19324 4.44778 6.19361ZM17.0417 17.0428H14.0786V12.4017C14.0786 11.2944 14.0569 9.87083 12.5367 9.87083C10.9928 9.87083 10.7575 11.0767 10.7575 12.3214V17.0431H7.79222V7.49861H10.6381V8.80194H10.6786C11.0747 8.05194 12.0425 7.26056 13.4858 7.26056C16.4875 7.26056 17.0419 9.23667 17.0419 11.8075L17.0417 17.0428Z"
                                fill="#00112E"
                              />
                            </svg>
                          </a>
                          <a
                            className="mail"
                            href="mailto:info@nationalpartners.com"
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="mail-icon"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M0 1.5C0 0.671573 0.671573 0 1.5 0H18.5C19.3284 0 20 0.671573 20 1.5V18.5C20 19.3284 19.3284 20 18.5 20H1.5C0.671573 20 0 19.3284 0 18.5V1.5ZM6 5C5.46957 5 4.96086 5.21071 4.58579 5.58579C4.21071 5.96086 4 6.46957 4 7V7.201L10 10.432L16 7.202V7C16 6.46957 15.7893 5.96086 15.4142 5.58579C15.0391 5.21071 14.5304 5 14 5H6ZM10.237 11.44L16 8.33696V13C16 13.5304 15.7893 14.0391 15.4142 14.4142C15.0391 14.7892 14.5304 15 14 15H6C5.46957 15 4.96086 14.7892 4.58579 14.4142C4.21071 14.0391 4 13.5304 4 13V8.33696L9.763 11.44C9.83584 11.4792 9.91727 11.4997 10 11.4997C10.0827 11.4997 10.1642 11.4792 10.237 11.44Z"
                                fill="#00112E"
                              />
                            </svg>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="main-footer">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 mb-4">
                <div className="footer-left-content text-left">
                  <img className="img-fluid footer-logo mb-3" src={logo} />
                  <p className="section-p text-white-50 f-300">
                    National Partners was founded by a team of highly qualified
                    and experienced finance executives who are dedicated to
                    providing the highest standards in the premium finance
                    industry.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 mx-auto mb-4">
                <div className="footer-center-content text-left">
                  <h6 className="footer-title text-white text-uppercase mb-4">
                    QUICK LINKS
                  </h6>
                  <ul className="footer-list">
                    <li className="footer-list">
                      <Link to="/premium-finance">Premium Finance</Link>
                    </li>
                    <li className="footer-list">
                      <Link to="/about-us">About Us</Link>
                    </li>
                    <li className="footer-list">
                      <Link to="/solutions">Solutions</Link>
                    </li>
                    <li className="footer-list">
                      <Link to="/contact-us">Contact Us</Link>
                    </li>
                    <li className="footer-list">
                      <Follow />
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="footer-right-content text-left">
                  <h6 className="footer-title text-white f-300 mb-3">
                    Subscribe to our newsletter and be the first to know about
                    our updates
                  </h6>
                  <WebriQForm
                    name="Newsletter"
                    id="newsletter-form"
                    className="newsletter-form-wrapper"
                    data-form-id="0ed8d68c-5037-4e30-bd85-6001393222a7"
                    data-thankyou-url="/thank-you"
                  >
                    <div className="form-group">
                      <div className="d-flex justify-content-start align-items-center mb-3">
                        <input
                          className="form-control footer-input"
                          type="text"
                          name="Email"
                          placeholder="Email Address"
                        />
                        <button
                          className="btn btn-primary footer-form-cta"
                          type="submit"
                        >
                          SUBSCRIBE
                        </button>
                      </div>
                      <div className="col-12">
                        <div className="form-group">
                          <div className="webriq-recaptcha" />
                        </div>
                      </div>
                    </div>
                  </WebriQForm>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="copyright">
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="copyright-content d-flex justify-content-between align-items-center">
                  <p className="copyright-p text-gold mb-0 mt-3">
                    © 2021 National Partners PFco, LLC All rights reserved.
                  </p>
                  <p className="copyright-p text-gold mb-0 mt-3">
                    Designed and Powered by:{" "}
                    <a
                      href="https://www.webriq.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gold webriq-cta"
                    >
                      WebriQ
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default footer
